/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState, useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import BlockOutput from 'content-renderer'

const DescriptionStyles = styled.div`
  margin-top: 16px;
  margin-bottom: 40px;
  .content {
    display: block;
    font: var(--p2Regular);
    svg {
      vertical-align: middle;
    }
    ul {
      font: inherit;
    }
    li {
      position: relative;
      margin: 8px 0;
      padding-left: 16px;
      display: flex!important;
      color: var(--turquoise);
      svg {
        margin-right: 8px;
      }
    }
    p {
      color: var(--baseSecondary);
      font: var(--p2Regular);
      margin-bottom: 0.5em;
      display: ${({ open }) => (open ? 'block' : 'none!important')};

      &.link {
        margin-bottom: 16px;
        margin-top: 16px;
      }
      &:first-child {
        overflow: hidden;
        display: block!important;
        display: -webkit-box!important;
        -webkit-line-clamp: ${({ open }) => (open ? 'initial' : '2')};
        -webkit-box-orient: vertical;
        &.link {
          /* display: flex!important; */
          /* flex-wrap: wrap; */
        }
      }
      a {
        margin: 0 5px;
        text-decoration: underline;
      }
    }
  }
  .showMore {
    line-height: 24px;
    font-size: 14px;
    color: var(--secondary);
    font-weight: bold;
    cursor: pointer;
    user-select: none;
    margin-top: 0.5em;
    display: block;
  }
  @media(min-width: 1024px) {
    margin-top: 16px;
    .content {
      font: var(--regular);
      p {
        font: var(--regular);
        display: block!important;
        &:first-child {
          -webkit-line-clamp: initial;
        }
        &.link {
          /* display: flex!important; */
        }
      }
    }
    .showMore {
      display: none;
    }
  }
`

function ClassDescription({ content }) {
  const [open, setOpen] = useState(false)
  const [showFullDescription, setShowFullDescription] = useState(false)
  function handleClick() {
    setOpen(!open)
  }
  useEffect(() => {
    const firstContent = document.querySelector('#class-content').querySelector('p')
    if (firstContent?.scrollHeight > firstContent?.clientHeight || content?.length > 1) {
      setShowFullDescription(true)
    } else {
      setShowFullDescription(false)
    }
  }, [content])
  return (
    <DescriptionStyles open={open}>
      <div className="content" id="class-content">
        {
          content && (
            <BlockOutput
              chunks={content}
              linkStyled
            />
          )
        }
      </div>
      {showFullDescription && (
        <span role="button" onClick={handleClick} className="showMore">
          {`MOSTRAR ${open ? 'MENOS' : 'MÁS'}`}
        </span>
      )}
    </DescriptionStyles>
  )
}

ClassDescription.propTypes = {
  // eslint-disable-next-line react/require-default-props
  content: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.object,
      type: PropTypes.string,
    }),
  ).isRequired,
}

export default ClassDescription
